import axios from "axios";
import { BASE_URL } from "../../../utils/EmpUtil";

/** React Query key for notifications Stripe account-lookup. */
export const STRIPE_ACCOUNT_LOOKUP_QUERY_KEY = "stripeAccountLookup";
export const STRIPE_ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND";

export const isStripeAccountNotFoundError = (error) =>
  error?.response?.status === 404 ||
  error?.message === STRIPE_ACCOUNT_NOT_FOUND;

export const shouldRetryStripeAccountLookup = (failureCount, error) =>
  !isStripeAccountNotFoundError(error) && failureCount < 3;

export const getStripeAccountSession = async (accountId) => {
  try {
    const accountSessionResponse = await axios.get(
      `${BASE_URL}/stripe/account-session?accountId=${accountId}`
    );
    return accountSessionResponse.data.clientSecret;
  } catch (error) {
    console.error("Failed to get Stripe account session:", error);
    throw error;
  }
};

export const lookupStripeAccount = async (dealerCommonId) => {
  try {
    const accountLookupResponse = await axios.get(
      `${BASE_URL}/stripe/account-lookup?dealerCommonId=${encodeURIComponent(
        dealerCommonId
      )}`
    );

    return {
      id: accountLookupResponse.data.id,
      detailsSubmitted: accountLookupResponse.data.detailsSubmitted,
      requirements: accountLookupResponse.data.requirements,
      created: accountLookupResponse.data.created,
    };
  } catch (error) {
    if (error.response?.status === 404) {
      const notFoundError = new Error(STRIPE_ACCOUNT_NOT_FOUND);
      notFoundError.response = error.response;
      throw notFoundError;
    }

    throw error;
  }
};

export const createStripeAccount = async ({
  dealerCommonId,
  dealerName,
  division,
  paCode,
  dealerType,
  marketName,
  regionName,
  zoneCode,
}) => {
  try {
    const response = await axios.post(`${BASE_URL}/stripe/account-create`, {
      dealerCommonId,
      dealerName,
      division,
      paCode,
      dealerType,
      marketName,
      regionName,
      zoneCode,
    });

    // Store the stripe account ID in sessionStorage
    if (response.data?.id) {
      sessionStorage.setItem("stripe.accountId", response.data.id);
    }

    return response.data;
  } catch (error) {
    console.error("Failed to create Stripe account:", error);
    throw error;
  }
};

export const getStripeAccountId = () => {
  return sessionStorage.getItem("stripe.accountId");
};

export const updateStripeAccount = async (accountId, data) => {
  console.log(accountId, data);

  try {
    const response = await axios.put(`${BASE_URL}/stripe/account-update`, {
      accountId,
      metadata: data,
    });

    return response.data;
  } catch (error) {
    console.error("Failed to update Stripe account:", error);
    throw error;
  }
};
